import 'css-chunk:src/applications/ProductFulfillmentApp/CreatorProductSelection/components/SendCatalog/PerMemberSelection.scss';export default {
  "PerMemberSelection": "_PerMemberSelection_1uiw4_1",
  "fullWidthSelect": "_fullWidthSelect_1uiw4_1"
};